import { writable } from 'svelte/store';

import positions from './positions';

let bannerCount = 0;

const isBannerValid = (banner) => {
  if (!banner || !banner.text || typeof banner.text !== 'string' || !positions.includes(banner.position)) {
    return false;
  }

  return true;
};

const addBanner = (banner, update) => {
  if (!isBannerValid(banner)) {
    throw new Error('Banner object is not valid');
  }

  const { id = bannerCount++, autohide = +banner.autohide, ...rest } = banner;

  update((banners) => {
    return [
      ...banners,
      {
        id,
        autohide,
        ...rest
      }
    ];
  });
};

const removeBanner = (bannerId, update) =>
  update((banners) => {
    return banners.filter(({ id }) => id !== bannerId);
  });

const clearBanners = (set) => set([]);

const createBannersStore = () => {
  const { subscribe, set, update } = writable([]);

  return {
    subscribe,
    addBanner: (banner) => addBanner(banner, update),
    removeBanner: (bannerId) => removeBanner(bannerId, update),
    clearBanners: () => clearBanners(set)
  };
};

export const bannersStore = createBannersStore();

export default bannersStore;
